import React, { FC, HTMLInputTypeAttribute } from "react";
import S from "./index.module.scss";
import clsx from "clsx";

interface IInputField {
  id: string;
  label: string;
  type: HTMLInputTypeAttribute;
  value?: string;
  placeholder?: string;
  required: boolean;
  disabled?: boolean;
  error: string;
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
}

const InputField: FC<IInputField> = ({
  id,
  label,
  type = "text",
  value,
  onChange,
  placeholder = "",
  required = false,
  disabled = false,
  error = "",
}) => {
  return (
    <div className={S.wrapper}>
      <label className={S.label} htmlFor={id}>
        {label}
        {required && "*"}
      </label>
      <input
        className={clsx(S.input, {
          [S["input--error"]]: !!error,
        })}
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        aria-invalid={!!error}
        aria-describedby={error}
      />
      {error && (
        <span className={S.error} id={`${id}-error`}>
          {error}
        </span>
      )}
    </div>
  );
};

export default InputField;
